import { PageHeader } from '@/design-system';

import { ElevationHistory } from './components/ElevationHistory';

/**
 * Wider 2-year elevation history. Reuses `ElevationHistory` (the same table
 * the `/elevation` landing page renders) with a wider lookback window and the
 * API's current 1000-row cap. The Cosmos `elevationRequests` container has a
 * default TTL of 730 days, so older rows age out automatically.
 *
 * Filters (env / status / requester) and the revoke action live in the table
 * component — keeping the page wrapper thin guarantees both views stay in
 * lockstep when filter or interaction logic changes.
 */
export function HistoryPage() {
  // 730d * 86_400_000ms — matches Cosmos `elevationRequests.defaultTtl` and
  // `CosmosElevationRepository.TwoYearTtlSeconds`.
  const twoYearsMs = 730 * 86_400_000;

  return (
    <div>
      <PageHeader
        title="Elevation history"
        description="Up to 2 years of the elevation requests you can access (currently capped at the newest 1000 rows). Filter by environment, status, or requester to narrow down."
      />
      <ElevationHistory
        windowMs={twoYearsMs}
        title="Accessible elevation requests (up to 2 years)"
        description="Shows up to the newest 1000 retained elevation requests you can access in Cosmos. Rows older than 2 years are auto-expired by the elevationRequests TTL."
        limit={1000}
      />
    </div>
  );
}
